export const avaliableActions = {
  salvar: 'Salvar',
  salvarNovo: 'Salvar e criar outro',
  cancelar: 'Cancelar',
  confirmar: 'Sim, confirmar exclusão',
  desistir: 'Não, desistir da exclusão',
  fechar: 'Fechar',
  alterar: 'Sim, confirmar alteração',
  desistirAlterar: 'Não, desistir da alteração',
};
